import type { ResourceGroup } from '@/data/learning-path/interfaces';

export const getResourceId = (resource: ResourceGroup) => {
  if ('external_link' in resource) return resource.external_link?.id;
  if ('course' in resource) return resource.course.id;
  throw new Error('Invalid resource');
};
